import HeroSection from "./heroSection";
import CardComponent from "./cardComponent";
import ScrollableFeedComponent from "../../generalComponents/scrollableFeedComponent";

export default function MainSolutionsComponent() {


    // TODO: Make pages for each of these
    // https://crisp.chat/en/livechat/livechat-customization/
    let featuresList = [
        {
            id: 2,
            title: "Process refunds instantly with store credit",
            description: "Refund any order in full or in part with store credit. Also supports refunding more than the original amount for a better refund experience.",
            tier: "starter"
        },
        {
            id: 3,
            title: "Gift cards, discount codes, and custom offers",
            description: "Customers can stack store credit with discount codes, gift cards, promotional codes, and custom offers.",
            tier: "starter"
        },
        {
            id: 5,
            title: "Shipping and Sales Tax",
            description: "Customers are able to apply their store credit towards their shipping fees and sales tax during their purchases.",
            tier: "starter"
        },
        {id: 6, title: "Dashboards and granular data tracking", description: "Gain realtime insights with comprehensive dashboards and granular data tracking.", tier: "starter"},
        {
            id: 6,
            title: "All platform support",
            description: "Use Pabloo on your computer or on the go.",
            tier: "starter"
        },
        {
            id: 7,
            title: "Direct integrations for Shopify and WooCommerce",
            description: "Pabloo integrates seamlessly with the leading e-commerce platforms.",
            tier: "starter"
        },
        {
            id: 8,
            title: "Loyalty program for north star metrics",
            description: "The Pabloo loyalty program incentivizes customer sign-ups, referrals, and purchases.",
            tier: "starter"
        },
        {
            id: 9,
            title: "White labeled and customizable",
            description: "Customizable views to perfectly match your shop's theme and branding, ensuring a flawless experience across all devices.",
            tier: "starter"
        },


        {
            id: 1,
            title: "Unlimited deposits, unlimited withdraws",
            description: "Simple, flat-rate pricing. No hidden fees per order.",
            tier: "plus"
        },
        {
            id: 4,
            title: "Credit expiration and product exclusion",
            description: "Maintain control over your store credit program by establishing expiration timelines and defining any product exclusions.",
            tier: "plus"
        },
        {
            id: 12,
            title: "Customer support assistant",
            description: "A dedicated customer support assistant will work closely with you to understand your needs.",
            tier: "plus"
        },

        {
            id: 4,
            title: "Full Checkout Support",
            description: "Supports Shopify Checkout, draft orders, and Wholesale.",
            tier: "plus",
            badge: ""
        },
        {
            id: 14,
            title: "Export data locally",
            description: "All store credit data can be saved locally for further analysis and integration with downstream applications.",
            tier: "plus"
        },  // Exporting customer data
        {
            id: 13,
            title: "Email & SMS notifications",
            description: "Customers are kept informed every time their store credit is added, deducted, or earn cashback.",
            tier: "pro"
        },

        {
            id: 15,
            title: "Revert any completed transaction",
            description: "Handles any error you make when making a deposit or withdraw. Allows you revert store credit changes, including purchases.",
            tier: "plus"
        },
        {
            id: 16,
            title: "Legal currency retailing",
            description: "Your business can legally sell store credit to customers, offering customers flexible payment options and fostering long-term brand engagement.",
            tier: "pro"
        },
        {
            id: 17,
            title: "Opt-in affiliate program",
            description: "Each participating customer has an affiliate link; a portion of each sale generated through the link goes back to the affiliate.",
            tier: "plus"
        },
        {
            id: 18,
            title: "AI Abandoned cart solution (2.5x increase in checkout)",
            description: "Recover lost sales with our AI-powered abandoned cart solution (Boosts checkout rates by 2.3x).",
            tier: "premium"
        },
        {
            id: 19,
            title: "Interactive data with Pabloo AI chat",
            description: "Ask your data anything with our AI assistant.",
            tier: "plus"
        },

        {
            id: 1,
            title: "Unlimited Cashback activities",
            description: "",
            tier: "pro",
            badge: "most_used",
            image: ""
        },
        {
            id: 2,
            title: "Cash App & Venmo Transfers",
            description: "Customers can purchase store credit directly from Cash App or Venmo account.",
            tier: "pro",
            badge: "new"
        },
        {
            id: 5, title: "Recurring Deposits", description: "Customer(s) recieve store credit on a recurring basis.",
            tier: "pro", badge: ""
        },
        {
            id: 6, title: "In-App Chat Support", description: "Get access to 24/7 support chat from within the app.",
            tier: "pro", badge: ""
        },
        {
            id: 8,
            title: "Purchase Triggers",
            description: "Engage with customers that exhibit purchase behavior, and need a little convincing.",
            tier: "pro",
            badge: ""
        },

        {
            id: 20,
            title: "AI tool to reengage dormant customers",
            description: "Analyzes expected Customer Lifetime Value (CLTV) to determine the ideal store credit amount to gift each customer, driving repeat purchases within 60 days and optimizing long-term customer value.",
            tier: "premium"
        },


        // Premium
        {
            id: 1,
            title: "Unlimited Membership subscribers",
            description: "Engage with customers that exhibit purchase behavior, and need a little convincing.",
            tier: "premium",
            badge: ""
        },



        {
            id: 9,
            title: "Templates & Customer Segments",
            description: "Create default templates to use for store credit activities and build customer segments.",
            tier: "plus",
            badge: ""
        },
    ]
    return (
        <div>
            <div>
                {/*<HeroSection/>*/}

                <div
                    className="bg-gray-900">
                    <div className="flex justify-center">
                        <div className="mx-12 my-16 w-full">
                            <ScrollableFeedComponent/>
                        </div>
                    </div>
                </div>
                <div
                    style={{background: "#faf2eb"}}>
                    <div className="flex justify-center">
                        <div className="mx-12 my-16 w-full">
                            <ScrollableFeedComponent type="blogs"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}